"use client"

import { useState } from "react"
import SignupModal, { SIGNUP_MODAL_ENABLED } from "./SignupModal"
import LoginModal from "./LoginModal"

export default function TryNowButton({ text, className, style, forceModal }: { text: string; className?: string; style?: React.CSSProperties; forceModal?: boolean }) {
    const [isSignupOpen, setIsSignupOpen] = useState(false)
    const [isLoginOpen, setIsLoginOpen] = useState(false)

    const enabled = forceModal || SIGNUP_MODAL_ENABLED

    if (!enabled) {
        return (
            <a className={className || "landing-btn landing-btn-primary"} href="/signup" style={style || { maxWidth: '100%', width: '100%' }}>
                <span>{text}</span>
                <ArrowIcon />
            </a>
        )
    }

    return (
        <>
            <button onClick={() => setIsSignupOpen(true)} className={className || "landing-btn landing-btn-primary"} style={style || { maxWidth: '100%', width: '100%' }}>
                <span>{text}</span>
                <ArrowIcon />
            </button>
            <SignupModal
                isOpen={isSignupOpen}
                onClose={() => setIsSignupOpen(false)}
                onSwitchToLogin={() => { setIsSignupOpen(false); setIsLoginOpen(true) }}
            />
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setIsLoginOpen(false)}
                onSwitchToSignup={() => { setIsLoginOpen(false); setIsSignupOpen(true) }}
            />
        </>
    )
}

const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <g clipPath="url(#clip0_trynow)">
            <path d="M5.5 12.707H19.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.5 18.707L19.5 12.707" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.5 6.70703L19.5 12.707" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_trynow">
                <rect width="24" height="24" fill="white" transform="translate(0.5 0.707031)" />
            </clipPath>
        </defs>
    </svg>
)
